import fetchServer from "../fetchServer";

export default async function rejectLoan({ id }) {
  let result = { return: 0, msg: "Something went wrong logging user!" };

  await fetchServer({
    method: "PUT",
    url: `/loans/reject/${id}`,
  })
    .then((res) => {
      if (res?.status === 200) {
        result = { return: 1, msg: "Welcome", data: res.data };
      } else {
        result["msg"] = res?.data?.error || result["msg"];
        result["data"] = res?.data;
      }
    })
    .catch((err) => {
      console.log(err);
      result["msg"] = err.message;
      console.log("Network Error!");
    });

  return result;
}
